import { render, staticRenderFns } from "./paipanSubmit.vue?vue&type=template&id=54a3ed0e"
import script from "./paipanSubmit.vue?vue&type=script&lang=js"
export * from "./paipanSubmit.vue?vue&type=script&lang=js"
import style0 from "./paipanSubmit.vue?vue&type=style&index=0&id=54a3ed0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports